"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jss = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jss = require("jss");
var _styles = require("@material-ui/styles");
/*:: import { type Jss } from 'jss';*/
var jss = exports.jss = (0, _jss.create)((0, _styles.jssPreset)());
/*:: type Props = {
  jss: Jss
};*/
var StylesProvider = function StylesProvider(props /*: Props*/) {
  return /*#__PURE__*/_react.default.createElement(_styles.StylesProvider, props);
};
StylesProvider.displayName = 'StylesProvider';
StylesProvider.defaultProps = {
  jss: jss
};
var _default = exports.default = StylesProvider;
//# sourceMappingURL=StylesProvider.js.map